/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as MediaRouteImport } from './routes/media'
import { Route as AgentsRouteImport } from './routes/agents'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as MediaIndexRouteImport } from './routes/media/index'
import { Route as BlogIndexRouteImport } from './routes/blog/index'
import { Route as AgentsIndexRouteImport } from './routes/agents/index'
import { Route as UsersIdRouteImport } from './routes/users/$id'
import { Route as BlogNewRouteImport } from './routes/blog/new'
import { Route as BlogIdRouteImport } from './routes/blog/$id'
import { Route as AgentsNewRouteImport } from './routes/agents/new'
import { Route as AgentsIdRouteImport } from './routes/agents/$id'

const SigninRoute = SigninRouteImport.update({
  id: '/signin',
  path: '/signin',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaRoute = MediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsRoute = AgentsRouteImport.update({
  id: '/agents',
  path: '/agents',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaIndexRoute = MediaIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => MediaRoute,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsIndexRoute = AgentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AgentsRoute,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogNewRoute = BlogNewRouteImport.update({
  id: '/blog/new',
  path: '/blog/new',
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIdRoute = BlogIdRouteImport.update({
  id: '/blog/$id',
  path: '/blog/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AgentsNewRoute = AgentsNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => AgentsRoute,
} as any)
const AgentsIdRoute = AgentsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AgentsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/agents': typeof AgentsRouteWithChildren
  '/media': typeof MediaRouteWithChildren
  '/signin': typeof SigninRoute
  '/agents/$id': typeof AgentsIdRoute
  '/agents/new': typeof AgentsNewRoute
  '/blog/$id': typeof BlogIdRoute
  '/blog/new': typeof BlogNewRoute
  '/users/$id': typeof UsersIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/blog': typeof BlogIndexRoute
  '/media/': typeof MediaIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/signin': typeof SigninRoute
  '/agents/$id': typeof AgentsIdRoute
  '/agents/new': typeof AgentsNewRoute
  '/blog/$id': typeof BlogIdRoute
  '/blog/new': typeof BlogNewRoute
  '/users/$id': typeof UsersIdRoute
  '/agents': typeof AgentsIndexRoute
  '/blog': typeof BlogIndexRoute
  '/media': typeof MediaIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/agents': typeof AgentsRouteWithChildren
  '/media': typeof MediaRouteWithChildren
  '/signin': typeof SigninRoute
  '/agents/$id': typeof AgentsIdRoute
  '/agents/new': typeof AgentsNewRoute
  '/blog/$id': typeof BlogIdRoute
  '/blog/new': typeof BlogNewRoute
  '/users/$id': typeof UsersIdRoute
  '/agents/': typeof AgentsIndexRoute
  '/blog/': typeof BlogIndexRoute
  '/media/': typeof MediaIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/agents'
    | '/media'
    | '/signin'
    | '/agents/$id'
    | '/agents/new'
    | '/blog/$id'
    | '/blog/new'
    | '/users/$id'
    | '/agents/'
    | '/blog'
    | '/media/'
    | '/settings'
    | '/users'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/signin'
    | '/agents/$id'
    | '/agents/new'
    | '/blog/$id'
    | '/blog/new'
    | '/users/$id'
    | '/agents'
    | '/blog'
    | '/media'
    | '/settings'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/agents'
    | '/media'
    | '/signin'
    | '/agents/$id'
    | '/agents/new'
    | '/blog/$id'
    | '/blog/new'
    | '/users/$id'
    | '/agents/'
    | '/blog/'
    | '/media/'
    | '/settings/'
    | '/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AgentsRoute: typeof AgentsRouteWithChildren
  MediaRoute: typeof MediaRouteWithChildren
  SigninRoute: typeof SigninRoute
  BlogIdRoute: typeof BlogIdRoute
  BlogNewRoute: typeof BlogNewRoute
  UsersIdRoute: typeof UsersIdRoute
  BlogIndexRoute: typeof BlogIndexRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/signin': {
      id: '/signin'
      path: '/signin'
      fullPath: '/signin'
      preLoaderRoute: typeof SigninRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media': {
      id: '/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof MediaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents': {
      id: '/agents'
      path: '/agents'
      fullPath: '/agents'
      preLoaderRoute: typeof AgentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media/': {
      id: '/media/'
      path: '/'
      fullPath: '/media/'
      preLoaderRoute: typeof MediaIndexRouteImport
      parentRoute: typeof MediaRoute
    }
    '/blog/': {
      id: '/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/': {
      id: '/agents/'
      path: '/'
      fullPath: '/agents/'
      preLoaderRoute: typeof AgentsIndexRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/new': {
      id: '/blog/new'
      path: '/blog/new'
      fullPath: '/blog/new'
      preLoaderRoute: typeof BlogNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/blog/$id': {
      id: '/blog/$id'
      path: '/blog/$id'
      fullPath: '/blog/$id'
      preLoaderRoute: typeof BlogIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/agents/new': {
      id: '/agents/new'
      path: '/new'
      fullPath: '/agents/new'
      preLoaderRoute: typeof AgentsNewRouteImport
      parentRoute: typeof AgentsRoute
    }
    '/agents/$id': {
      id: '/agents/$id'
      path: '/$id'
      fullPath: '/agents/$id'
      preLoaderRoute: typeof AgentsIdRouteImport
      parentRoute: typeof AgentsRoute
    }
  }
}

interface AgentsRouteChildren {
  AgentsIdRoute: typeof AgentsIdRoute
  AgentsNewRoute: typeof AgentsNewRoute
  AgentsIndexRoute: typeof AgentsIndexRoute
}

const AgentsRouteChildren: AgentsRouteChildren = {
  AgentsIdRoute: AgentsIdRoute,
  AgentsNewRoute: AgentsNewRoute,
  AgentsIndexRoute: AgentsIndexRoute,
}

const AgentsRouteWithChildren =
  AgentsRoute._addFileChildren(AgentsRouteChildren)

interface MediaRouteChildren {
  MediaIndexRoute: typeof MediaIndexRoute
}

const MediaRouteChildren: MediaRouteChildren = {
  MediaIndexRoute: MediaIndexRoute,
}

const MediaRouteWithChildren = MediaRoute._addFileChildren(MediaRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AgentsRoute: AgentsRouteWithChildren,
  MediaRoute: MediaRouteWithChildren,
  SigninRoute: SigninRoute,
  BlogIdRoute: BlogIdRoute,
  BlogNewRoute: BlogNewRoute,
  UsersIdRoute: UsersIdRoute,
  BlogIndexRoute: BlogIndexRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
